interface LoginScreenProps {
	onLogin: () => void;
	authError: string | null;
}

/** Map OAuth error codes to user-friendly messages. */
function getErrorMessage(error: string): string {
	switch (error) {
		case "access_denied":
			return "You denied access. Please sign in to use PIA.";
		case "invalid_request":
			return "The sign-in request was invalid. Please try again.";
		case "server_error":
		case "temporarily_unavailable":
			return "Zoho is temporarily unavailable. Please try again later.";
		default:
			return "An error occurred during sign-in. Please try again.";
	}
}

/**
 * Centred login screen with PIA branding and "Sign in with Zoho" button.
 * Shows an error banner if the OAuth callback returned an error.
 */
export default function LoginScreen({ onLogin, authError }: LoginScreenProps) {
	return (
		<div className="login-screen">
			<div className="login-card">
				<h1 className="login-logo">PIA</h1>
				<p className="login-subtitle">Project Intelligence Assistant</p>
				<p className="login-description">
					Ask natural language questions about your Zoho Projects data.
					Sign in with your Zoho account to get started.
				</p>

				{authError && (
					<div className="login-error" role="alert">
						{getErrorMessage(authError)}
					</div>
				)}

				<button
					className="login-btn"
					onClick={onLogin}
					type="button"
				>
					Sign in with Zoho
				</button>

				<p className="login-footer">
					Built by{" "}
					<img
						src="/caldere-logo.png"
						alt="Caldere Associates"
						className="login-footer-logo"
					/>
				</p>
			</div>
		</div>
	);
}
